import { useEffect } from 'react';

import { storeClickId } from '@/utils/click-id-store';

/**
 * Guarda o `?clickId=` do pouso para que ele sobreviva à navegação dentro da aba.
 *
 * Roda uma vez por carga de página, no `_app`, ao lado do `useUtmTracker`. **Um único ponto de
 * escrita, e num efeito** — nunca dentro de `getClickId()`, que nove componentes de gateway chamam no
 * corpo do render: escrever ali seria efeito colateral em render, e o StrictMode invoca render duas
 * vezes. É o mesmo motivo pelo qual o redirect do trial mora em `pages/trial/index.tsx` e não dentro
 * do `TrialLayoutSwitcher`.
 *
 * Lê só a URL, não o cookie: quando o cookie existe ele já persiste sozinho por 30 dias e ganha na
 * leitura de qualquer forma, então copiá-lo para cá só criaria uma segunda cópia para divergir.
 */
export function useClickIdCapture(enabled = true): void {
  useEffect(() => {
    if (!enabled || typeof window === 'undefined') return;

    try {
      storeClickId(new URL(window.location.href).searchParams.get('clickId'));
    } catch {
      // URL inválida no jsdom/edge: não há campanha a guardar, e isto nunca pode derrubar o _app.
    }
  }, [enabled]);
}
